'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useMemo, useEffect } from 'react';
import JobItem from './JobItem.js';
import Button from '../Button/index.js';
import { colors } from '../Colors/index.js';
import PlusIcon from '../Images/PlusIcon/index.js';
import { getSpecialJob } from '../JobYouWillLove/services.js';
import Col from '../LayoutSystem/Col.js';
import Row from '../LayoutSystem/Row.js';
import Popup from '../Popup/index.js';
import { showToast } from '../Toast/index.js';
import Typography from '../Typography/index.js';
import { ELanguage } from '../Utils/constants.js';
import { decrypt } from '../Utils/helpers.js';
import { buildCompanyUrl } from '../Utils/urlBuilder.js';
import { followCompany } from '../services/company/index.js';
import { DEFAULT_SUCCESS_CODE } from '../services/company/const.js';
import { CompanyItemWrapper, BannerSection, CoverWrapper, CompanyHeader, CompanyLogo, CompanyInfo, CompanyName, ContentSection, EmptyTextWrapper, FollowSection } from './CompanyItem.css.js';
import { EMPTY_COMPANY_IMAGE, EMPTY_BANNER_IMAGE } from './const.js';
import translations from './translations.js';

function CompanyCardSquare(props) {
    var _this = this;
    var companyInfo = props.companyInfo, langCode = props.langCode, user = props.user, baseMsUrl = props.baseMsUrl, baseImgUrl = props.baseImgUrl, baseUrl = props.baseUrl, appMode = props.appMode, _a = props.displayCompanyEvenHaveNoJob, displayCompanyEvenHaveNoJob = _a === void 0 ? false : _a, _b = props.decryptToken, decryptToken = _b === void 0 ? false : _b;
    var _c = useState(companyInfo), company = _c[0], setCompany = _c[1];
    var _d = useState(companyInfo !== null ? (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.isFollowed) === 1 : false), isFollowed = _d[0], setFollowed = _d[1];
    var _e = useState(companyInfo !== null && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) ? companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount : 1), followCount = _e[0], setFollowCount = _e[1];
    var _f = useState(false), isShowUnfollowDialog = _f[0], setShowUnfollowDialog = _f[1];
    var t = function (text) {
        if (langCode === ELanguage.EN) {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var isCCP = [1, 3].includes(Number(companyInfo.profilePublishedSiteMask));
    var companyUrl = buildCompanyUrl({
        companyId: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || -1,
        companySlug: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companySlug) || '',
        companyCCPSlug: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companySlug) || '',
        langCode: langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI,
        isCCP: isCCP
    });
    var userToken = decryptToken ? decrypt((user === null || user === void 0 ? void 0 : user.accessToken) || '') : (user === null || user === void 0 ? void 0 : user.accessToken) || '';
    var doFollow = function (isFollowed) { return __awaiter(_this, void 0, void 0, function () {
        var response, toastTitle, toastMessage, count, count;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (user === null || !user.accessToken) {
                        return [2 /*return*/];
                    }
                    if (companyInfo === null || !companyInfo.companyId) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, followCompany(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', companyInfo.companyId, isFollowed ? 1 : 0, userToken, langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI)];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.code) !== DEFAULT_SUCCESS_CODE) {
                        return [2 /*return*/];
                    }
                    toastTitle = t('Unfollowed');
                    toastMessage = t("You'll stop receive the newest jobs from this company.");
                    if (isFollowed) {
                        toastTitle = t('Yay! Thanks for following');
                        toastMessage = t('You will receive the newest jobs from this company.');
                        count = followCount + 1;
                        setFollowCount(count);
                    }
                    else {
                        count = followCount - 1;
                        setFollowCount(count);
                    }
                    showToast(toastTitle, toastMessage, 'success');
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickFollow = function () {
        if (user === null || !user.accessToken) {
            var loginEvent = new CustomEvent('LOGIN_POPUP', {
                detail: {
                    langCode: langCode
                }
            });
            window.dispatchEvent(loginEvent);
            return;
        }
        if (companyInfo === null || !companyInfo.companyId) {
            return;
        }
        if (isFollowed) {
            setShowUnfollowDialog(true);
        }
        else {
            setFollowed(!isFollowed);
            doFollow(!isFollowed);
        }
    };
    var handleOnClickCompanyDetail = function () {
        if (companyInfo === null || !companyInfo.companyId) {
            return;
        }
        var link = document.createElement('a');
        link.href = companyUrl;
        link.target = isCCP ? '_blank' : '_self';
        document.body.appendChild(link);
        link.click();
        link.remove();
    };
    var onClickConfirmUnfollow = function () {
        setShowUnfollowDialog(false);
        setFollowed(false);
        doFollow(false);
    };
    // combine default logo | companyLogoURL | companyLogoUrlCCP => companyLogoURL
    var companyLogo = useMemo(function () {
        var _a;
        var logo = companyInfo.companyLogoURL ? companyInfo.companyLogoURL : "".concat(baseImgUrl, "/").concat(EMPTY_COMPANY_IMAGE);
        if ((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 1) {
            logo = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoUrlCCP) ? companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoUrlCCP : (_a = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL) !== null && _a !== void 0 ? _a : '';
        }
        if (logo === '') {
            logo = "".concat(baseImgUrl, "/").concat(EMPTY_COMPANY_IMAGE);
        }
        return logo;
    }, [companyInfo]);
    var getJobAttribute = function (jobs) { return __awaiter(_this, void 0, void 0, function () {
        var res_1, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getSpecialJob({
                            baseUrl: baseMsUrl || '',
                            accessToken: userToken,
                            jobs: jobs
                        })];
                case 1:
                    res_1 = _b.sent();
                    if (res_1.data && res_1.data.length > 0) {
                        setCompany(__assign(__assign({}, companyInfo), { bannerDesktopUri: companyInfo.bannerDesktopUri
                                ? companyInfo.bannerDesktopUri
                                : "".concat(baseImgUrl, "/").concat(EMPTY_BANNER_IMAGE), companyLogoURL: companyLogo, jobs: (_a = companyInfo.jobs) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
                                var _a, _b, _c, _d, _e, _f, _g;
                                return __assign(__assign({}, item), { isMatching: (_a = res_1.data[index]) === null || _a === void 0 ? void 0 : _a.isMatching, isSaved: (_b = res_1.data[index]) === null || _b === void 0 ? void 0 : _b.isSaved, isApplied: (_c = res_1.data[index]) === null || _c === void 0 ? void 0 : _c.isApplied, isBlackList: (_d = res_1.data[index]) === null || _d === void 0 ? void 0 : _d.isBlackList, redirectTo: (_e = res_1.data[index]) === null || _e === void 0 ? void 0 : _e.redirectTo, jobInvitation: (_g = (_f = res_1.data[index]) === null || _f === void 0 ? void 0 : _f.jobInvitation) !== null && _g !== void 0 ? _g : { jobInvitationId: 0, status: 0 } });
                            }) }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (companyInfo !== null) {
            if (companyInfo.jobs && companyInfo.jobs.length > 0) {
                getJobAttribute(companyInfo.jobs);
            }
            setFollowed(companyInfo !== null ? companyInfo.isFollowed === 1 : false);
            setFollowCount(companyInfo !== null && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) ? companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount : 1);
        }
    }, [companyInfo]);
    var jobs = (company === null || company === void 0 ? void 0 : company.jobs) || [];
    jobs.forEach(function (job) {
        var _a;
        if (job.salary === 'Thương lượng') {
            job.salary = t('Negotiate');
        }
        if (job.prettySalary === 'Thương lượng') {
            job.prettySalary = t('Negotiate');
        }
        job.companyLogo = (_a = companyInfo.companyLogoURL) !== null && _a !== void 0 ? _a : '';
    });
    var companyName = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName;
    if (isCCP && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyNameCCP) !== '') {
        companyName = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyNameCCP) || '';
    }
    return jobs.length > 0 || displayCompanyEvenHaveNoJob ? (React__default.createElement(CompanyItemWrapper, { datatype: 'item-wrapper', className: 'view_job_item' },
        React__default.createElement(BannerSection, null,
            React__default.createElement(CoverWrapper, null,
                React__default.createElement("img", { src: company.bannerDesktopUri, alt: companyName || '', placeholder: 'blur', loading: 'lazy' })),
            React__default.createElement(CompanyHeader, null,
                React__default.createElement(CompanyLogo, { href: companyUrl, target: isCCP ? '_blank' : '_self' },
                    React__default.createElement("img", { src: company.companyLogoURL, alt: companyName || '', placeholder: 'blur', loading: 'lazy' })),
                React__default.createElement(CompanyInfo, null,
                    React__default.createElement(CompanyName, { href: companyUrl, target: isCCP ? '_blank' : '_self' }, companyName),
                    React__default.createElement(Row, null,
                        React__default.createElement(Col, null,
                            React__default.createElement(Typography, { variant: 'p', name: 'paragraph', size: 'small', color: colors.grey[60] },
                                followCount,
                                " ",
                                followCount > 1 ? t('followers') : t('follower'))),
                        React__default.createElement(Col, null,
                            React__default.createElement(Button, { type: 'info', outline: 'none', onClick: handleOnClickFollow, iconComponent: React__default.createElement(PlusIcon, null), iconPosition: 'left', style: { padding: '2px', height: 32, float: 'right' } }, isFollowed ? t('Following') : t('Follow'))))))),
        React__default.createElement(ContentSection, null, jobs.length > 0 ? (jobs.map(function (job) { return (React__default.createElement(JobItem, { key: job.jobId, job: job, user: user, langCode: langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI, baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', appMode: appMode !== null && appMode !== void 0 ? appMode : '', decryptToken: decryptToken, initData: props.initData })); })) : (React__default.createElement(EmptyTextWrapper, null, t('No opening jobs')))),
        React__default.createElement(FollowSection, null,
            React__default.createElement(Button, { type: 'outline', isOutline: true, onClick: handleOnClickCompanyDetail }, t('View company profile'))),
        isShowUnfollowDialog && (React__default.createElement(Popup, { isShow: isShowUnfollowDialog, lang: langCode !== null && langCode !== void 0 ? langCode : ELanguage.VI, styleOption: { size: 'sm' }, text: {
                header: t('Unfollow company?'),
                primaryBtn: t('Unfollow')
            }, onClose: function () { return setShowUnfollowDialog(false); }, onClickPrimary: onClickConfirmUnfollow }, t('You will not able to received notifications from this company.'))))) : null;
}

export { CompanyCardSquare as default };
//# sourceMappingURL=index.js.map
